import banner1 from "../../img/autoagendamientov2/banner1.jpg"
import logo1 from '../../img/autoagendamientov2/logo_ike_home.png'

export default function Banner1(){

    return (
        <div className="d-banner-1">
            <div className="d-1 pos-title pt-5">
                <h1 className="mb-0 colorTitle title-1">VIDEO</h1>
                <h1 className="colorTitle title-2">Consultas</h1>
            </div>
            <div className="d-logo-center">
                <img 
                    src={logo1}
                    alt="Ike"
                    width={150}
                />
            </div>
            <div className="d-2 d-none d-md-block">
                <img 
                    src={banner1}
                    alt="Ike"
                    width={800}
                />
            </div>
        </div>
    )
}